module.exports = __webpack_public_path__ + "img/dajian_icon.29ce3dd0.png";